import React from 'react';
import intl from "react-intl-universal";
import {observer} from "mobx-react-lite";
import {useRootStore} from "@stores/AppStateContext";

import {ContextMenuInterface} from "../ContextMenuInterface";

import {ContextMenuInEditor} from "../../../components/ContextMenuInEditor";
import {ItemModelSnapshotOut} from "../../../../stores/WorkspaceStore";

export interface AddToClusterContextMenuProps extends ContextMenuInterface {
    onSelect: (selectedId: string | null) => void;
    itemId: string;
}

export const AddToClusterContextMenu = observer(
    (
        {
            onSelect,
            itemId,
            isDark,
            handleClose,
        }: AddToClusterContextMenuProps
    ) => {
        const rootStore = useRootStore();
        const itemMST = rootStore.view.workspace!.items.get(itemId)!;
        const availableClusters = rootStore.getAvailableClusters(itemMST);

        return (
            <ContextMenuInEditor
                isDark={isDark}
                handleClose={handleClose}
                headerText={intl.get('add-to-cluster.add_to_cluster').d('Add to cluster')}
                itemGroups={[availableClusters.map((availableCluster: ItemModelSnapshotOut) => {
                    return {
                        text: availableCluster.name ? availableCluster.name : intl.get('common.untitled_cluster').d('Untitled cluster'),
                        onClick: () =>  onSelect(availableCluster.id),
                        id: availableCluster.id,
                    }
                })]}
                filterQuery={rootStore.clusterFilter}
                onNewOption={() => onSelect(null)}
                isInline={true}
            />
        )
    })
